module.exports = __webpack_public_path__ + "img/alipay.46703d79.png";